/**
 * @generated SignedSource<<0ddca9cceaaa167027235f60cd10f533>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraRadioSelectField_Platform$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null;
    readonly isRequired: boolean | null;
  } | null;
  readonly fieldOptions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly value: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly name: string;
  readonly selectedOption: {
    readonly value: string | null;
  } | null;
  readonly " $fragmentType": "JiraRadioSelectField_Platform";
};
export type JiraRadioSelectField_Platform$key = {
  readonly " $data"?: JiraRadioSelectField_Platform$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraRadioSelectField_Platform">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JiraRadioSelectField_Platform",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isRequired"
        },
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    },
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "selectedOption",
      "plural": false,
      "selections": (v0/*: any*/)
    },
    {
      "concreteType": "JiraOptionConnection",
      "kind": "LinkedField",
      "name": "fieldOptions",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOptionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v0/*: any*/)
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraRadioSelectField"
};
})();

(node as any).hash = "92f411b7b38c29e27a50cf8ceb71b938";

export default node;
